import { render, staticRenderFns } from "./bookLink.vue?vue&type=template&id=e46b9b9c&scoped=true&"
import script from "./bookLink.vue?vue&type=script&lang=js&"
export * from "./bookLink.vue?vue&type=script&lang=js&"
import style0 from "./bookLink.vue?vue&type=style&index=0&id=e46b9b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46b9b9c",
  null
  
)

export default component.exports